import React from 'react';

import { useAgeAssurance } from '../hooks/use-age-assurance';

import { AgeAssuranceBlockedScreen } from './age-assurance-blocked-screen';
import { AgeAssurancePendingScreen } from './age-assurance-pending-screen';

type AgeAssuranceGateProps = {
  children: React.ReactNode;
};

export const AgeAssuranceGate = ({ children }: AgeAssuranceGateProps) => {
  const { state, retry } = useAgeAssurance();

  if (state === 'pending') {
    return <AgeAssurancePendingScreen />;
  }

  if (state === 'blocked') {
    return <AgeAssuranceBlockedScreen onRetry={() => void retry()} />;
  }

  return <>{children}</>;
};
